import i18next from 'i18next'
import z, { ZodType } from 'zod'

import { LazyLoad, lazyLoadValues } from 'types/lazyLoad'

export const gamAdRenderMargin: ZodType<number> = z.number().int().min(0)
export const gamAdRequestMargin: ZodType<number> = z.number().int().min(0)
export const kvTargetingAndPrebidAuction: ZodType<number> = z.number().int().min(0)
export const lazyLoadTargetingPrebidAuctionEnabled: ZodType<boolean> = z.boolean()
export const lazyLoadType: ZodType<LazyLoad> = z.enum(lazyLoadValues)
export const mobileScaling: ZodType<number> = z.number().min(0).multipleOf(0.01)

export const lazyLoadingSchema = z.object({
  gamAdRenderMargin,
  gamAdRequestMargin,
  kvTargetingAndPrebidAuction,
  lazyLoadTargetingPrebidAuctionEnabled,
  lazyLoadType: lazyLoadType,
  mobileScaling,
})

export const validateLazyLoadingSchema = (
  {
    gamAdRenderMargin,
    gamAdRequestMargin,
    kvTargetingAndPrebidAuction,
    lazyLoadTargetingPrebidAuctionEnabled,
    lazyLoadType,
  }: Partial<z.infer<typeof lazyLoadingSchema>>,
  ctx: z.RefinementCtx,
  pathPrefix?: string,
): void => {
  const i18nPrefix: string =
    'features/domain:form.viewabilityTools.basicSettings.lazyLoadingEnabled.options.'

  const prefix: string = pathPrefix ? pathPrefix + '.' : ''

  if (lazyLoadTargetingPrebidAuctionEnabled) {
    if (kvTargetingAndPrebidAuction !== undefined && gamAdRequestMargin !== undefined) {
      if (kvTargetingAndPrebidAuction < gamAdRequestMargin) {
        ctx.addIssue({
          code: 'custom',
          message: i18next.t(
            i18nPrefix + 'kvTargetingAndPrebidAuction.error.greaterThanGamAdRequestMargin',
          ),
          path: [`${prefix}kvTargetingAndPrebidAuction`],
        })
      }
    }
    if (gamAdRequestMargin !== undefined && kvTargetingAndPrebidAuction !== undefined) {
      if (gamAdRequestMargin > kvTargetingAndPrebidAuction) {
        ctx.addIssue({
          code: 'custom',
          message: i18next.t(
            i18nPrefix + 'gamAdRequestMargin.error.lessThanKvTargetingAndPrebidAuction',
          ),
          path: [`${prefix}gamAdRequestMargin`],
        })
      }
    }
  }

  if (lazyLoadType === 'googlePublisherTagsLazyLoad') {
    if (gamAdRequestMargin !== undefined && gamAdRenderMargin !== undefined) {
      if (gamAdRequestMargin < gamAdRenderMargin) {
        ctx.addIssue({
          code: 'custom',
          message: i18next.t(i18nPrefix + 'gamAdRequestMargin.error.greaterThanGamAdRenderMargin'),
          path: [`${prefix}gamAdRequestMargin`],
        })
      }
    }
    if (gamAdRenderMargin !== undefined && gamAdRequestMargin !== undefined) {
      if (gamAdRenderMargin > gamAdRequestMargin) {
        ctx.addIssue({
          code: 'custom',
          message: i18next.t(i18nPrefix + 'gamAdRenderMargin.error.lessThanGamAdRequestMargin'),
          path: [`${prefix}gamAdRenderMargin`],
        })
      }
    }
  }
}
